import React, { useEffect, useState } from 'react';

import { ReactComponent as MoreIcon } from '@assets/icons/more.svg';

import LoaderComponent from '@components/LoaderComponent';
import NoData from '@components/NoData';
import { toastError, toastSuccess } from '@components/Toast';

import AddDepartment from '@features/admin/components/AddDepartment';
import EditDepartment from '@features/admin/components/EditDepartment';

import ApiClient from '@lib/apiClient';

import { changeDateFormat } from '@utils/Util';

const DepartmentList = ({ search, showAdd, setShowAdd, totalItems }) => {
	const [departmentList, setDepartmentList] = useState([]);
	const [department, setDepartment] = useState([]);
	const [loading, setLoading] = useState(false);
	const [idToEdit, setIdToEdit] = useState(null);

	const getDepartmentList = () => {
		setLoading(true);
		ApiClient.GET('getDepartmentList')
			.then((response) => {
				let data = response.data;
				setDepartmentList(data);
				setDepartment(data);
				setLoading(false);
			})
			.catch(() => {
				setLoading(false);
				toastError('Something went wrong!');
			});
	};

	const onDeleteDepartment = async (depId) => {
		setLoading(true);
		await ApiClient.DELETE('deleteDepartment', {}, `${depId}`)
			.then(({ data }) => {
				setLoading(false);
				let deleteResult = departmentList.filter((item) => item.id !== depId);
				setDepartmentList(deleteResult);
				let deleteDepResult = department.filter((item) => item.id !== depId);
				setDepartment(deleteDepResult);
				toastSuccess(data.message);
			})
			.catch(({ response }) => {
				setLoading(false);
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
			});
	};

	useEffect(() => {
		getDepartmentList();
	}, []);

	useEffect(() => {
		let searchResult = departmentList.filter(
			(item) => item.name.toLowerCase().indexOf(search.toLowerCase()) !== -1
		);
		setDepartmentList(search ? searchResult : department);
	}, [search]);

	useEffect(() => {
		totalItems(`${departmentList.length} Departments`);
	}, [departmentList]);

	return (
		<LoaderComponent loading={loading}>
			<div className="admin-list-table">
				<table className="table with-border">
					<thead>
						<tr>
							<th className="type-name">Department name</th>
							<th className="created-by">Created by</th>
							<th className="created-at">Created at</th>
							<th className="description">Description</th>
							<th>Action</th>
						</tr>
					</thead>
					<tbody>
						{departmentList &&
							departmentList.map((item, i) => (
								<tr key={i}>
									<td>{item.name}</td>
									<td>{item.createdBy.name}</td>
									<td>{changeDateFormat(item.createdAt, 'YYYY-MM-DD', 'DD MMM, YYYY')}</td>
									<td>{item.description}</td>
									<td>
										<div className="option">
											<div className="dropdown">
												<button
													className="btn btn-default dropdown-toggle"
													type="button"
													id="menu1"
													data-toggle="dropdown"
													aria-expanded="true"
												>
													<MoreIcon />
												</button>
												<ul
													className="dropdown-menu dropdown-menu-right shadow-lg"
													role="menu"
													aria-labelledby="menu1"
													x-placement="bottom-end"
												>
													<li role="presentation" className="px-4 pb-3 pt-3">
														<span
															className="font-weight-normal  text-black cursor-pointer"
															onClick={() => setIdToEdit(item.id)}
														>
															Edit
														</span>
													</li>
													<li role="presentation" className="px-4 pb-3">
														<span
															className="font-weight-normal  text-black cursor-pointer"
															onClick={() => onDeleteDepartment(item.id)}
														>
															Delete
														</span>
													</li>
												</ul>
											</div>
										</div>
									</td>
								</tr>
							))}
					</tbody>
				</table>
				{departmentList.length === 0 && <NoData message={'No result found'} />}
			</div>

			<AddDepartment show={showAdd} setShow={setShowAdd} callback={getDepartmentList} />
			{idToEdit && (
				<EditDepartment
					show={idToEdit !== null}
					setIdToEdit={setIdToEdit}
					callback={getDepartmentList}
					idToEdit={idToEdit}
				/>
			)}
		</LoaderComponent>
	);
};

export default DepartmentList;
